import React from 'react';
import ctaStyles from '@/components/CTA/CTA.module.scss';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { messages } from '@/containers/FeatureAnnouncementContainer/messages';
import styles from './LoadMoreButton.module.scss';

export interface LoadMoreButtonProps {
  label: string;
  onClick: () => void;
  loading: boolean;
  visible: boolean;
}

export const LoadMoreButton: React.FC<LoadMoreButtonProps> = ({
  label,
  onClick,
  loading,
  visible,
}) => {
  const { formatMessage } = useIntl();

  if (!visible) return null;

  return (
    <div className={styles.container}>
      <button
        className={classNames(ctaStyles['cta-btn'], ctaStyles['cta-btn_type__secondary'])}
        onClick={onClick}
        disabled={loading}
      >
        {loading ? formatMessage(messages.loading) : label}
      </button>
    </div>
  );
};
